"use client";

import http from "@/libs/config/http";
import { useState } from "react";

const Form = ({ t }) => {
  const [status, setStatus] = useState("");

  const [formData, setFormData] = useState({
    title: "",
    phone: "",
    message: "",
    email: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "phone" ? value.replace(/\D/g, "") : value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending");

    try {
      const form = new FormData();
      form.append("key", "contact-form");
      form.append("title", formData.title);
      form.append(
        "form_data",
        JSON.stringify({
          phone: formData.phone,
          message: formData.message,
          email: formData.email,
        })
      );

      const response = await fetch(
        "https://apiwebadmin.getqcall.com/api/v1/form-data/send",
        {
          method: "POST",
          // Do not set Content-Type for FormData; browser will add boundary
          body: form,
          redirect: "follow",
        }
      );

      let data;
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        try {
          data = await response.json();
        } catch (_) {
          data = null;
        }
      } else {
        data = await response.text().catch(() => null);
      }

      if (response.ok) {
        setFormData({
          title: "",
          phone: "",
          message: "",
          email: "",
        });
        setStatus("success");
        console.log("success", data);
      } else {
        const message =
          (data && (data.message || data.error)) ||
          `Request failed with status ${response.status}`;
        setStatus("error");
        console.error("Submit failed:", message, {
          status: response.status,
          data,
        });
      }
    } catch (error) {
      console.error("Network or unexpected error:", error);
      setStatus("error");
    }
  };

  return (
    <form className="contactRight" onSubmit={handleSubmit}>
      <h2>{t["Get in touch"]}</h2>
      <p>{t["formDesc"]}</p>
      <div className="inputChild">
        <input
          type="text"
          name="title"
          placeholder={t["Name and Surname"]}
          value={formData.title}
          onChange={handleChange}
          required
        />
      </div>
      <div className="inputChild">
        <input
          type="email"
          name="email"
          placeholder={t["Your Email"]}
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="inputChild">
        <input
          type="tel"
          name="phone"
          placeholder={t["Your Phone  number"]}
          value={formData.phone}
          onChange={handleChange}
          required
        />
      </div>
      <div className="textChild">
        <textarea
          placeholder={t["Note for us"]}
          name="message"
          id=""
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
      </div>
      <div className="formBottom">
        {status === "success" && (
          <p className="successMessage">{t["Message sent successfully!"]}</p>
        )}
        <button type="submit" className="orangeButton">
          {status === "Sending" ? t["Sending..."] : t["Send to us"]}
        </button>
      </div>
    </form>
  );
};

export default Form;
